import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-145b0378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-button-control" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "switch-button-label" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthSwitch',
  props: {
    isEnabled: { type: Boolean },
    color: {}
  },
  emits: ["toggleAuthType"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const toggle = () => {
  emits("toggleAuthType", !props.isEnabled);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["switch-button", { enabled: props.isEnabled }]),
      style: _normalizeStyle({ '--color': props.color }),
      onClick: toggle
    }, _hoisted_3, 6),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})